import React, { useRef } from 'react';
import styled from 'styled-components';
import {
	AnimationContainer,
	AnimationImageAsset,
	AnimationImageElement,
	AnimationPositionElement,
} from '../AnimationCommon';
import Functions from '@client/style/Functions';
import MobileHaze3Svg from '@client/assets/svgs/animations/mobile-haze-3.svg';
import DesktopHaze3Svg from '@client/assets/svgs/animations/desktop-haze-3.svg';
import { useSurroundingColors } from '@client/modules/shared/UseSurroundingColors';

const StyledAnimationContainer = styled(AnimationContainer)`
	/* position: relative;
	height: 700px;
	/* width: 100%; */
	/* height: 500px; */
	/* width: 100%; */
	align-self: center;
	justify-self: center;
	img {
		max-width: 100%;
		height: auto;
	}
	overflow: hidden;
`;

const HazeContainer = styled.div<{ fill?: string }>`
	width: 100vw;
	svg {
		width: 100%;
		height: auto;
		fill: ${props => props.fill || ''};
	}
`;
const ColorWrapper = styled.div`
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	position: absolute;
`;

const TopColor = styled.div<{ bgColor?: string }>`
	top: 0;
	left: 0;
	width: 100%;
	height: 1%;
	z-index: -1;
	background-color: ${props => props.bgColor || ''};
	position: absolute;
`;

const BottomColor = styled.div<{ bgColor?: string }>`
	bottom: 0;
	left: 0;
	width: 100%;
	height: 99%;
	z-index: -1;
	background-color: ${props => props.bgColor || ''};
	position: absolute;
`;

const MobileSpan = styled.span`
	display: block;
	${Functions.breakpoint('mobile')} {
		display: none;
	}
`;
const DesktopSpan = styled.span`
	display: none;
	${Functions.breakpoint('mobile')} {
		display: block;
	}
`;

const WishingWell = () => {
	const image = new AnimationImageAsset('https://www.datocms-assets.com/80292/1670845480-onskebronden-desktop.png', {
		width: 558,
		height: 673,
	});

	return <AnimationImageElement image={image} />;
};

export default function IllustrationWishingWell() {
	const moduleRef = useRef<HTMLDivElement | null>(null);
	const backgroundColors = useSurroundingColors(moduleRef);

	return (
		<StyledAnimationContainer
			height={1100}
			width={900}
			ref={moduleRef}
			breakpoints={{ mobile: { height: 1300, width: 2600 }, ultra: { height: 2000, width: 4000 } }}
		>
			<ColorWrapper>
				<TopColor bgColor={backgroundColors[0]}></TopColor>
				<BottomColor bgColor={backgroundColors[1]}></BottomColor>
			</ColorWrapper>
			<AnimationPositionElement position={{ anchorY: 'bottom', y: '-6%', origin: '50% 100%' }}>
				<HazeContainer fill={backgroundColors[0]}>
					<MobileSpan>
						<MobileHaze3Svg />
					</MobileSpan>
					<DesktopSpan>
						<DesktopHaze3Svg />
					</DesktopSpan>
				</HazeContainer>
			</AnimationPositionElement>

			<AnimationPositionElement
				position={{
					scale: 1.5,
					anchorY: 'bottom',
					y: '-6%',
					origin: '50% 100%',
					anchor: 'center',
					x: '-50%',
					breakpoints: { mobile: { scale: 0.7 }, tablet: { scale: 0.8 }, desktop: { scale: 1 }, ultra: { scale: 1.2 } },
				}}
			>
				<WishingWell />
			</AnimationPositionElement>
		</StyledAnimationContainer>
	);
}
